export const host = process.env.REACT_APP_BASEURL; 
const adminBase = `${host}/api/admin`;
export const loginroute = `${host}/api/auth/login`;
export const registerroute = `${host}/api/auth/register`;
export const googleRegisterRoute=`${host}/api/auth/google-register`;
export const logoutroute = `${host}/api/auth/logout`;
export const allusersroute = `${host}/api/auth/allusers`;
export const totalUsersRoute =`${host}/api/auth/total-users`;
export const singleUserRoute =`${host}/api/auth/singleuser`;
export const userProfile =`${host}/api/auth/profile`;
export const searchUser=`${host}/api/auth/search`;
export const userBatch=`${host}/api/auth/batch`;
export const onlineUsersRoute=`${host}/api/online-users`;
export const contactbymessages = `${host}/api/auth/contactsmessages`;
export const sendmessageroute = `${host}/api/messages/addmsg`;
export const recievemessageroute = `${host}/api/messages/getmsg`;
export const setavatarroute = `${host}/api/auth/setavatar`;
export const sendsurpriseroute=`${host}/api/surprises/addsurprise`;
export const receivesurpriseroute=`${host}/api/surprises/getsurprises`;
export const markMessagesAsReadRoute=`${host}/api/messages/mark-read`;
export const deletemessageroute=`${host}/api/messages/deleteMsgs`;
export const deleteonemessageroute=`${host}/api/messages/delete-single`;
export const updatefcmtoken=`${host}/api/auth/update-fcm-token`;
export const requestReset=`${host}/api/auth/request-password-reset`;
export const reset=`${host}/api/auth/reset`;
export const allowUser=`${host}/api/auth/allow-user`;
export const rejectUser=`${host}/api/auth/reject-user`;
export const requestingusers=`${host}/api/auth/requestingusers`;
export const requesttosell=`${host}/api/auth/request-to-sell`;
export const allowedusers=`${host}/api/auth/allowed-users`;
export const bulkUpdateUserStatus=`${host}/api/auth/bulk-update-status`;
export const clickpesaInitiate = `${host}/api/clickpesa/initiate`;
export const clickpesaStatus = `${host}/api/clickpesa/status`; // Cart.jsx appends /:orderReference
export const pesapalInitiate = `${host}/api/pesapal/initiate`;
export const pesapalStatus = `${host}/api/pesapal/status`;     // Cart.jsx appends /:orderTrackingId
export const ordersubmit =`${host}/api/checkout`;
export const orderslist =`${host}/api/ordered`;
export const updateOrderProcessed =`${host}/api/order/processed`;
export const updateOrderShipped =`${host}/api/order/shipped`;
export const trackOrder = `${host}/api/orders/track`; // GET  /:orderCode?email=
export const confirmItemReceived = `${host}/api/orders/track`; // PUT  /:orderCode/confirm-item
export const releaseFundsRoute = `${host}/api/orders`; // PUT /:orderId/release-funds
export const rejectOrderRoute = `${host}/api/orders`;  // PUT /:orderId/reject
export const deleteOrder = `${host}/api/order`;
export const postInteractions =`${host}/api/log-interaction`;
export const retrieveInteractions =`${host}/api/user-interactions`;
export const deleteaccount =`${host}/api/auth/delete-account`;
export const getAllAgents=`${host}/api/agents/getAllAgents`;
export const getAllActiveAgents=`${host}/api/agents/getAllActiveAgents`;
export const createAgent=`${host}/api/agents/createAgent`;
export const searchAgents=`${host}/api/agents/searchAgents`;
export const updateAgent=`${host}/api/agents/updateAgent`;
export const getAgentsWithOrderStats=`${host}/api/agents/getAgentsWithOrderStats`;
export const deactivateAgent=`${host}/api/agents/deactivateAgent`;
export const activateAgent=`${host}/api/agents/activateAgent`;
export const searchUsersForAgent = `${host}/api/agents/search-users`;
export const sendBulkEmails= `${host}/api/auth/send-bulk-emails`;
export const getSubscriptionStatus= `${host}/api/auth/subscription-status`;
export const startFreeTrial = `${host}/api/auth/start-free-trial`;
export const subscribeUser = `${host}/api/auth/process-subscription`;

// ---- Admin role management (new) ----
export const getMyRole = `${adminBase}/me`;
export const grantAdminRole = `${adminBase}/grant`;
export const revokeAdminRole = `${adminBase}/revoke`;
export const listAdmins = `${adminBase}/list`;


  